import { newPalette } from 'components/Charts/Utils';
import React from 'react';
import ReactSpeedometer, { Transition } from 'react-d3-speedometer';
import { connect } from 'react-redux';
import selectors from 'store/selectors';
import '../riskMapping.scss';
import { RiskMapDataType2 } from '../types';
import { useTheme } from '@material-ui/styles';
import { gradientColors } from 'components/Settings/Palette/utils';

type PopUpProps = {
  firmRiskGroup?: number;
  riskRatedFunds: RiskMapDataType2[];
  selectedFund: RiskMapDataType2;
  style: any;
  timeHorizon: string;
};

const PopUp: React.FC<PopUpProps> = ({
  firmRiskGroup = 10,
  riskRatedFunds,
  selectedFund,
  style,
  timeHorizon
}) => {
  const theme = useTheme() as any;
  const isCombination = riskRatedFunds[0].allocation !== 1;
  const isModelPortfolio = !!riskRatedFunds[0].cip_model_portfolio_id;
  const colour = isCombination
    ? newPalette[9]
    : isModelPortfolio
      ? newPalette[8]
      : newPalette[4];
  const investmentType = isCombination
    ? 'Combination'
    : isModelPortfolio
      ? 'Model Portfolio'
      : 'Fund';
  return (
    <div className="popUpContainer" style={style}>
      <div
        className="popUpTitle"
        style={{ backgroundColor: 'white', color: 'black' }}
      >
        {selectedFund.allocation === 1 ? (
          <div>{selectedFund.name}</div>
        ) : (
          <>
            <div>{`${riskRatedFunds[0].allocation * 100}% - ${
              riskRatedFunds[0].name
            }`}</div>
            <div>{`${riskRatedFunds[1].allocation * 100}% - ${
              riskRatedFunds[1].name
            }`}</div>
            <div></div>
          </>
        )}
      </div>
      <div style={{ backgroundColor: colour }} className="popUpTitle">
        <>{`${investmentType}`}</>
      </div>
      <div style={{ marginBottom: 'rem', width: '100%', textAlign: 'left' }}>
        <div>
          <span style={{ fontWeight: 'bold' }}>Time Horizon: </span>
          {timeHorizon}
        </div>
      </div>
      <div style={{ marginBottom: '1rem', width: '100%', textAlign: 'left' }}>
        <div>
          <span style={{ fontWeight: 'bold' }}>Risk Level: </span>
          {selectedFund.actual_risk_score}
        </div>
      </div>
      <div style={{ width: '100%', height: '125px', overflow: 'hidden' }}>
        <ReactSpeedometer
          needleHeightRatio={0.8}
          needleColor={'#DA7542'}
          segments={firmRiskGroup}
          minValue={0.5}
          needleTransition={Transition.easeElastic}
          needleTransitionDuration={1}
          forceRender={true}
          maxValue={firmRiskGroup + 0.5}
          value={selectedFund.actual_risk_score}
          segmentColors={gradientColors(theme)}
          currentValueText=""
          paddingHorizontal={2}
          paddingVertical={2}
          width={205}
        />
      </div>
    </div>
  );
};

export default connect((state: any) => ({
  firmRiskGroup: selectors.firmSelectors.riskGroup(state)
}))(PopUp);
